import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import * as XLSX from 'xlsx';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { finalize, map } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-upload-reportage-images',
  templateUrl: './upload-reportage-images.component.html',
  styleUrls: ['./upload-reportage-images.component.sass']
})
export class UploadReportageImagesComponent implements OnInit {
  type_accept: string = '.jpg, .jpeg, .png';
  selectedFiles: File = null;
  studentForm: FormGroup;
  stages: any;
  stagesListSubs: Subscription;
  private routeSub: Subscription;
  gradesListSubs: Subscription;
  grades: any;
  title: string;
  message: string;
  ok_txt: string;
  showPrimarySpinner: boolean = false;
  files: any[] = [];
  files_list: any[] = [];


  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar

  ) { }

  public getStages(schoolID: string) {
    this.stages = [{ 'id': null, 'name': "" }]
    this.grades = [{ 'id': null, 'name': "" }]
    this.studentForm.controls["stages"].setValue('')
    this.studentForm.controls["grades"].setValue('')
    // this.studentForm.controls["lines"].setValue('')

    this.stagesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        this.stages = res;
        this.stages = [{ 'id': null, 'name': "" }].concat(this.stages)
        // this.studentForm.controls["stages"].setValue(res[0]['id'])
        // this.getGrades(res[0]['id'])
      },
        console.error
      );
  }

  public getGrades(stageID: string) {
    this.studentForm.controls["grades"].setValue('')

    var params = {}
    params['school_id'] = ''
    params['stage_id'] = stageID

    this.gradesListSubs = this.dataService
      .getGrades(params)
      .subscribe(res => {
        this.grades = res;
        this.grades = [{ 'id': null, 'name': "" }].concat(this.grades)
        // this.studentForm.controls["grades"].setValue(res[0]['id'])
        // this.getLines(res[0]['id'])
      },
        console.error
      );
  }

  ngOnInit() {
    this.studentForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
    });

    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    this.routeSub = this.route.params.subscribe(params => {
      if (params.id_school) {
        
        this.getStages(params.id_school)

      }
    })
  }

  uploadImages() {
    // this.showPrimarySpinner = true;

    if (this.files.length != 0) {
      // TODO call create user
      // upload to storage
      // this.uploadFilesSimulator(0);
      let index = 0;
      for (const item of this.files) {
        let text = item.name.toUpperCase()
        let name = text.split('.')
        this.files_list.push(name[0])
        let params = {}
        this.routeSub = this.route.params.subscribe(r => {
          params['reportage_id'] = r.id_reportage
        })
        
        const filePath = 'reportages/' + params['reportage_id'] + '/' + name[0] + "_original";
        const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
        const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, item);
        uploadTask.snapshotChanges().pipe(
          finalize(() => {
            params['url'] = filePath.slice(0, -9)
            params['name'] = name[0]
            this.dataService.uploadReportageImages(params).subscribe(data => {
              this.uploadFilesSimulator(index);
              index += 1;
            })
          })
        ).subscribe();
      }

    }
    else {
      this.translate.get('alerts.images_required').subscribe(res4 => {
        // this.showPrimarySpinner = false;
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
        return false;
      })
    }
  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    // else {
    //   this.selectedSecondaryFiles = event.target.files;
    // }

  }

  //--------------Drag and Drop functions-------------//
  /**
     * on file drop handler
     */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.files_list.splice(index, 1)
  }

  /**
   * Simulate the upload process
   */
   uploadFilesSimulator(index: number) {
    setTimeout(() => {
      const progressInterval = setInterval(() => {
        if (this.files[index].progress === 100) {
          clearInterval(progressInterval);
          if (index === this.files.length - 1) {
            this.translate.get('alerts.upload_successfull').subscribe(res4 => {
              // this.showPrimarySpinner = false;
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
              this.router.navigateByUrl(`reportages`);
            })
            return;
          }
        } else {
          this.files[index].progress += 20;
        }
      }, 100);
      
    }, 500);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    let lets_continue = false;
    for (const item of files) {
      let name = item.name.split('.')
      if (name[0].length == 6) {
        lets_continue = true
      }

    }
    if (lets_continue == true) {
      for (const item of files) {
        item.progress = 0;
        this.files.push(item);
      }
      // this.uploadFilesSimulator(0);
    }
    else {
      alert('Formato nombre imagenes incorrecto')
      return false
    }

  }


  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  //-----------------End Drag and Drop----------------//

}
